import React from 'react';
import PropTypes from 'prop-types';

/* eslint react/no-danger: 0 */
const FoldedCornerContainer = ({ html }) => (
    <div
        className="folded-corner folded-corner-white-bggray"
        dangerouslySetInnerHTML={{
            __html: html
        }}
    />
);

FoldedCornerContainer.propTypes = {
    html: PropTypes.string
};

export default FoldedCornerContainer;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/folded-corner-container.jsx